import { useLanguage } from "@/context/LanguageContext";
import { LEGAL_DOCS } from "@/data/legal";
import { Seo } from "@/components/Seo";
import { Reveal } from "@/components/Reveal";

export default function Legal({ doc }) {
  const { lang } = useLanguage();
  const d = LEGAL_DOCS[doc];
  const isCookies = doc === "cookies";

  const resetConsent = () => {
    localStorage.removeItem("rvfilm-cookie-consent");
    window.location.reload();
  };

  return (
    <main className="relative px-6 lg:px-12 pt-20 md:pt-28 pb-28" data-testid={`${doc}-page`}>
      <Seo title={`RV FILM — ${d.title}`} description={`${d.title} del sito RV FILM (rvfilm.it).`} />
      <div className="max-w-3xl mx-auto">
        <Reveal y={12}>
          <p className="f-mono text-[11px] uppercase tracking-[0.3em] text-red-500 mb-6">RV FILM · Legal</p>
          <h1 className="f-display text-4xl sm:text-5xl font-black tracking-tight" data-testid={`${doc}-title`}>
            {d.title}
          </h1>
          <p className="mt-4 f-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">{d.updated}</p>
        </Reveal>
        <div className="mt-14 space-y-10">
          {d.sections.map((s, i) => (
            <Reveal key={i} delay={Math.min(i * 0.04, 0.2)}>
              <section>
                <h2 className="f-display text-xl md:text-2xl font-bold tracking-tight text-slate-100">{s.h}</h2>
                <p className="mt-3 text-sm md:text-base text-slate-400 leading-relaxed">{s.p}</p>
              </section>
            </Reveal>
          ))}
        </div>
        {isCookies && (
          <Reveal delay={0.1}>
            <button
              onClick={resetConsent}
              data-testid="cookie-reset-button"
              className="mt-14 inline-flex items-center gap-2 border border-white/15 hover:border-red-600/60 hover:text-red-500 transition-colors f-mono text-[10px] uppercase tracking-[0.2em] text-slate-300 px-6 py-3.5 rounded-full"
            >
              {lang === "it" ? "Modifica il consenso cookie" : "Change cookie consent"}
            </button>
          </Reveal>
        )}
      </div>
    </main>
  );
}
